export default __webpack_public_path__ + "static/media/medical_11.28707e50.jpg";